import React, { RefAttributes, memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextBox, react } from "uikit";

import LabeledField from "../../../../../../components/LabeledField";
import translationPath from "../../constants/translationPath";

import InternalController from "./Controller";

/** Ссылка на политику возврата — общее поле для всех платёжных систем. */
const RefundPolicyBase = react.withController<
	RefundPolicy.PropsBase,
	RefundPolicy.Controller
>(({ value, onChange, controller }) => {
	const [error, setError] = useState(false);
	controller.setContext({ value, setError });

	const { t } = useTranslation();

	const changeHandler = useCallback(
		(newValue: string) => {
			setError(false);
			onChange(newValue);
		},
		[onChange],
	);

	return (
		<LabeledField
			label={t(`${translationPath}.modal.refundPolicyUrl`) || ""}
		>
			<TextBox.TextBox
				error={error}
				placeholder={
					t(
						`${translationPath}.modal.placeholders.refundPolicyUrl`,
					) || ""
				}
				value={value ?? ""}
				onChange={changeHandler}
			/>
		</LabeledField>
	);
}, InternalController);
const RefundPolicy = memo(RefundPolicyBase);

declare namespace RefundPolicy {
	type Ref = InternalController | null;
	type Controller = InternalController;
	interface PropsBase {
		value: string;
		onChange: (x: string) => void;
	}
	type Props = PropsBase & RefAttributes<Ref>;
}

export default RefundPolicy;
